import React from 'react';
import PropTypes from 'prop-types';
import { FDIcon, FDLabelText, FDStack } from '@facet-wealth/design';

const AuthenticationFactorListItemEnabled = ({ authenticationFactorResource }) => {
  return (
    <FDStack alignItems={'center'} spacing={1}>
      <FDIcon
        icon={'checkCircleIcon'}
        size={'sm'}
        color={'success'}
        test={`security-settings-icon-authentication-factor-${authenticationFactorResource.attr('authenticationType')}-enabled`}
      />
      <FDLabelText size={'lg'} value={'Enabled'} />
    </FDStack>
  );
};

AuthenticationFactorListItemEnabled.propTypes = {
  authenticationFactorResource: PropTypes.object.isRequired,

};

export default AuthenticationFactorListItemEnabled;
